export default "<tabbed-modal-tab tab=\"$ctrl.tab\">\r\n\t<information-tab export-log=\"$ctrl.exportLog\"></information-tab>\r\n</tabbed-modal-tab>\r\n";